var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H7.5L9.5 2.5H17.5C18.0523 2.5 18.5 2.94772 18.5 3.5V13.5C18.5 14.0523 18.0523 14.5 17.5 14.5H1.5C0.947715 14.5 0.5 14.0523 0.5 13.5Z",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5H13M13 8.5L10 11.5M13 8.5L10 5.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.18f9633f8c4bec7571a46c1d448b4155.svg";
export { ForwardRef as ReactComponent };